export enum CurrencyType { 
    BTC = 'BTC', 
    RBTC = 'RBTC' 
};